/**
 * 打开弹窗
 * @param options {object} 参数
 */
import findParent from "./custom/findParent";
function childOpen(options) {
  let parentWin = findParent();
  if (parentWin && parentWin.parentOpen) {
    parentWin.parentOpen(options, window)
  }
}

export default childOpen
